export const DEFAULT_BRNAD_ITEM = {
  title: 'zerone',
  logo: require('@assets/images/logo/logo.svg')
};
